import moment from 'moment';
import { translate } from 'components/Translation';

export const calculateExpiryDate = (months: number): string =>{
    const currentDate = moment();
    const expiryDate = currentDate.add(months / 12, 'years');
    return `${translate('add.new.line.validity')} ${expiryDate.format('DD/MM/YYYY')}`;
}